import i18next from "i18next";

export const READABLE_DATETIME_FORMAT = () => i18next.language == 'de' ? "iiii, dd.MM.yyyy, HH:mm 'Uhr'" : "iiii, MM/dd/yyyy, hh:mm a";
export const READABLE_DATETIME_FORMAT_SHORT = () => i18next.language == 'de' ? "iiiiii, dd.MM HH:mm 'Uhr'" : "iiiiii, MM/dd hh:mm a";
export const READABLE_DATE_FORMAT = () => i18next.language == 'de' ? "iiii, dd.MM.yyyy" : "iiii, MM/dd/yyyy";
export const DB_DISPLAY_DATE = () => i18next.language == 'de' ? 'dd.MM.yyyy' : 'MM/dd/yyyy';
export const DB_DISPLAY_DATE_SHORT = () => i18next.language == 'de' ? 'dd.MM.yy' : 'MM/dd/yy';
export const READABLE_DATE_FORMAT_WITH_TIME = () => i18next.language == 'de' ? "dd.MM.yyyy, HH:mm 'Uhr'" : "MM/dd/yyyy, hh:mm a";
export const DB_TIME = () => i18next.language == 'de' ? "HH:mm" : 'hh:mm a';
export const DB_TIME_TEXTED = () => i18next.language == 'de' ? "HH:mm 'Uhr'" : 'hh:mm a';
export const DAY_AND_DATE = () => i18next.language == 'de' ? "iiiiii, dd.MM.yyyy" : "iiiiii, MM/dd/yyyy";

export const DAY_AND_DATE_SHORT = () => i18next.language == 'de' ? "iiiiii, dd.MM" : "iiiiii, MM/dd";
export const DAY_AND_DATE_SHORT_WITH_YEAR = () => i18next.language == 'de' ? "iiiiii, dd.MM.yy" : "iiiiii, MM/dd/yy";
export const DAY_AND_DATE_SHORT_WITH_YEAR_AND_TIME = () => i18next.language == 'de' ? "iiiiii, dd.MM.yy" : "iiiiii, MM/dd/yy";

export const DAY_NAME = () => "iiiiii";

export const DB_DATETIME_FORMAT = () => 'yyyy-MM-dd HH:mm:ss';
export const DB_DATE = () => 'yyyy-MM-dd';

export const CHECK_DATE = () => "yyyyMMdd";
export const CHECK_DATE_TIME = () => "yyyyMMddHHmm";